<template>
    <div class="lookPresentCabinDetail">
      <navbar :showShadow='false' :scrollChange='false' :tabId="2"></navbar>
      <div class="topTap dis_f_c_c">
          <div class="content dis_f_l_c">
            <div class="order dis_f_l_c">
              <div class="title dis_f_c_c" :class="{titleActive:orderStatus>=1}">1</div>
              <div class="orderTiTle" :class="{orderTiTleActive:orderStatus>=1}">填写订单</div>
            </div>
            <img class="img" src="@/images/common/pay_hui.png" alt="" v-if="orderStatus<1">
            <img class="img" src="@/images/common/pay_blue.png" alt="" v-else>
            <div class="order dis_f_l_c">
              <div class="title dis_f_c_c" :class="{titleActive:orderStatus>=2}">2</div>
              <div class="orderTiTle" :class="{orderTiTleActive:orderStatus>=2}"> 30分钟审核确认 </div>
            </div>
            <img class="img" src="@/images/common/pay_hui.png" alt="" v-if="orderStatus<2">
            <img class="img" src="@/images/common/pay_blue.png" alt="" v-else>
            <div class="order dis_f_l_c">
              <div class="title dis_f_c_c" :class="{titleActive:orderStatus>=3}">3</div>
              <div class="orderTiTle" :class="{orderTiTleActive:orderStatus>=3}">下单出运</div>
            </div>
          </div>
      </div>
      <div class="banxin">
        <detail-order v-if="orderStatus == 1"></detail-order>
        <detail-confirm v-if="orderStatus == 2"></detail-confirm>
        <detail-complete v-if="orderStatus == 3"></detail-complete>
      </div>
    </div>
</template>

<script>
import detailOrder from './components/detail-order.vue';
import detailComplete from './components/detail-complete.vue';
import detailConfirm from './components/detail-confirm.vue';
import { mapState } from "vuex";
export default {
  name: "lookPresentCabinDetail",
  data() {
    return {
      // orderStatus:1,//1订单 2审核 3 完成
    }
  },
  components: {
    detailOrder,
    detailConfirm,
    detailComplete,
  },
  watch: {},
  computed: {
    ...mapState("order", {
        orderStatus: (state) => state.orderStatus,
    }),
  },
  created() {
  },
  // 销毁事件
  destroyed() {
    let object = {
      orderStatus: 1,
      code_url: "",
      orderId: "",
      order_form: {},
      object: {}, //总对象  包含code_url  orderId
    };
    this.$store.dispatch("order/orderMethods", object);
  },
  methods: { 

  },
};
</script>
<style lang="scss" scoped>
  .lookPresentCabinDetail{
    width: 100%;
    padding-top: 138px;
    position: relative;
    background: #F5F9FF;
    // min-height: 100vh;
    .topTap{
      position: fixed;
      top: 74px;
      left: 0;
      width: 100%;
      height: 64px;
      background: #ffffff;
      box-shadow: 0px 4px 12px 0px #EBEEF3;
      z-index: 99;
      .content{
        .img{
          width: 64px;
          height: 10xp;
          margin: 0 20px;
        }
        .order{
          .title{
            width: 20px;
            height: 20px;
            background: #E7EAEF;
            border-radius: 50%;
            color: #808795;
            font-size: 12px;
            margin-right: 10px;
          }
          .titleActive{
            background:var(--themeColor);
            color: #ffffff;
          }
          .orderTiTle{
            font-size: 14px;
            font-family: PingFang SC;
            font-weight: bold;
            color: #808795;
          }
          .orderTiTleActive{
            color: var(--themeColor);
          }
        }
      }
    }
    .banxin{
      // width: 1200px;
      margin: 0 auto;
    }
  }
</style>